import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/crm/auth.service';
import swal from 'sweetalert2';  

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {

  constructor(
    public authService: AuthService,public router:Router
  ) { }
  public loading = false;
  facturas;
  id_usuario;
  id_cliente;
  ngOnInit() {
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    this.id_usuario=localStorage.getItem("usuario");
    try {
      this.facturas=localStorage.getItem("facturas");  
    } catch (error) {
      this.facturas=0;
    }
    this.secc_(2);
    this.ls_cliente_preventa();
   
  }
  fn_filter(){
    
  }
  preventas;
  bdn_edit=0;
  seguimiento(itm){ 
    localStorage.setItem("cliente",itm.id);
    localStorage.setItem("cliente_",JSON.stringify(itm) );
    this.router.navigate(['/seguimiento_clientev3']);
  }
  bndbtn_ed=false;
  can_edcli(){
    this.bdn_edit=0;
    this.secc_(2);
  }

  responsables=[];
  get_responsable(id){
    let postData={
      id:id,
    };
    console.log(postData);
    this.authService.service("/api/get_responsable_cliente",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.responsables=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      });   
  }
  nvo_resp(){
    this.secc_(3);
    this.bndbtn_ed=false;
    this.responsable={
      id:0,
      nombre:"",
      proveedor:"",
      paterno:"",
      materno:"",
      cargo:"",
      rs:"",
      rfc:"",
      correo:"",
      tel1:"",
      ext1:"",
      direccion:""      
    };
  }
  valida_resp(){
    return true;
  }
  edita_resp(itm){
      this.secc_(3);
      this.responsable={
        id:itm.id,
        proveedor:itm.proveedor,
        nombre:itm.nombre,
        paterno:itm.paterno,
        materno:itm.materno,
        cargo:itm.cargo,
        rs:itm.razonsocial,
        rfc:itm.rfc,
        correo:itm.correo,
        tel1:itm.telefono,
        ext1:itm.ext,
        direccion:itm.direccion        
      };
  }
  eli_resp(itm){
    let postData={
      id:itm.id
    };
    console.log(postData);
    this.authService.service("/api/eli_resp",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.get_responsable(this.preventa.id);
        this.secc_(1)
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      });
    
  }
  responsable={
    id:0,
    nombre:"",
    proveedor:"",
    paterno:"",
    materno:"",
    cargo:"",
    rs:"",
    rfc:"",
    correo:"",
    tel1:"",
    ext1:"",
    direccion:""    
  };
  fn_gda_resp(){
    let postData={
      responsable:this.responsable,
      id_cliente:this.preventa.id
    };
    console.log(postData);
    this.authService.service("/api/gda_resp",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.get_responsable(this.preventa.id);
        this.secc_(2)
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      }); 
  }
  fn_upd_resp(){    
    let postData={
      responsable:this.responsable
    };
    console.log(postData);
    this.authService.service("/api/upd_resp",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.get_responsable(this.preventa.id);
        this.secc=1;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      }); 

  }
  elim_cli(itm){
    if(confirm("Confirm to delete this record?")==false)return;
    let postData={
      id:itm.id,
    };
    console.log(postData);
    this.authService.service("/api/elim_cli",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_cliente_preventa();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      }); 
  }
  bndNvoREsp;
  ncliente(){
    this.bndNvoREsp=false;
    this.responsables=[];
    this.secc_(1);
    this.bdn_edit=1;
    this.preventa.id=0;
    this.preventa.nombre="";
    this.preventa.paterno="";
    this.preventa.materno="";
    this.preventa.rs="";
    this.preventa.rfc="";
    this.preventa.cargo="",
    this.preventa.correo="";
    this.preventa.tel1="";
    this.preventa.tel2="";
    this.preventa.ext1="";
    this.preventa.ext2="";
    this.preventa.pais="";
    this.preventa.estado="";
    this.preventa.municipio="";
    this.preventa.colonia="";
    this.preventa.calle="";
    this.preventa.cp="";
    this.preventa.medio="";
    this.bndbtn_ed=false;

  }
  edita_preventa(itm){
    this.bndNvoREsp=true;
    this.bndbtn_ed=true;
    this.secc_(1);
    this.get_responsable(itm.id);
    this.bdn_edit=1;
    this.preventa.id=itm.id;
    this.preventa.nombre=itm.nombre;
    this.preventa.paterno=itm.paterno;
    this.preventa.materno=itm.materno;
    this.preventa.rs=itm.razonsocial;
    this.preventa.rfc=itm.rfc;
    this.preventa.cargo=itm.cargo,
    this.preventa.correo=itm.correo;
    this.preventa.tel1=itm.telefono;
    this.preventa.tel2=itm.telefono2;
    this.preventa.ext1=itm.ext1;
    this.preventa.ext2=itm.ext2;
    this.preventa.pais=itm.pais;
    this.preventa.estado=itm.estado;
    this.preventa.municipio=itm.municipio;
    this.preventa.colonia=itm.colonia;
    this.preventa.calle=itm.calle;
    this.preventa.cp=itm.cp;
    this.preventa.medio=itm.medio;

  }
  ls_cliente_preventa(){
    this.loading=true;
    this.preventas=[];
    let postData={
      id_usuario:this.id_usuario,
      id_cliente:this.id_cliente
    };
    var sc="";
    if(this.facturas==1){

      sc="/api/get_cliente_id_cliente"
    }else{
      sc="/api/get_cliente_id"
    }
    this.authService.service(sc,postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.preventas=data;
          }          
          this.loading=false; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

  }
  secc;
  valida_cliente(){
    return true
  }
  fn_upd_cliente(){
    if(this.valida_cliente()==true){
      let postData={
        nombre:this.preventa.nombre,
        paterno:this.preventa.paterno,
        materno:this.preventa.materno,
        razonsocial:this.preventa.rs,
        rfc:this.preventa.rfc,
        correo:this.preventa.correo,
        cargo:this.preventa.cargo,
        telefono:this.preventa.tel1,
        telefono2:this.preventa.tel2,
        ext1:this.preventa.ext1,
        ext2:this.preventa.ext2,
        pais:this.preventa.pais,
        estado:this.preventa.estado,
        municipio:this.preventa.municipio,
        colonia:this.preventa.colonia,
        calle:this.preventa.calle,
        cp:this.preventa.cp,
        medio:this.preventa.medio,
        id:this.preventa.id
      };
      this.authService.service("/api/upd_cliente_preventa",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.secc_(2);
            this.ls_cliente_preventa();
      
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

    }
  }
  fn_gda_cliente(){
    if(this.valida_cliente()==true){
      let postData={
        id_cliente:this.id_cliente,
        nombre:this.preventa.nombre,
        paterno:this.preventa.paterno,
        materno:this.preventa.materno,
        razonsocial:this.preventa.rs,
        rfc:this.preventa.rfc,
        correo:this.preventa.correo,
        telefono:this.preventa.tel1,
        telefono2:this.preventa.tel2,
        cargo:this.preventa.cargo,
        ext1:this.preventa.ext1,
        ext2:this.preventa.ext2,
        pais:this.preventa.pais,
        estado:this.preventa.estado,
        municipio:this.preventa.municipio,
        colonia:this.preventa.colonia,
        calle:this.preventa.calle,
        cp:this.preventa.cp,
        medio:this.preventa.medio
      };
      console.log(postData)
      this.authService.service("/api/gda_cliente_id_cliente",postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.secc_(2);
            this.ls_cliente_preventa();
      
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

    }
  }
  preventa={
    id:0,
    nombre:"",
    paterno:"",
    materno:"",
    cargo:"",
    rs:"",
    rfc:"",
    correo:"",
    tel1:"",
    tel2:"",
    ext1:"",
    ext2:"",
    pais:"",
    estado:"",
    municipio:"",
    colonia:"",
    calle:"",
    cp:"",
    medio:""
  }
  limpia_form(){
    this.preventa.id=0;
    this.preventa.nombre="";
    this.preventa.paterno="";
    this.preventa.materno="";
    this.preventa.cargo=""
    this.preventa.rs="";
    this.preventa.rfc="";
    this.preventa.correo="";
    this.preventa.tel1="";
    this.preventa.tel2="";
    this.preventa.ext1="";
    this.preventa.ext2="";
    this.preventa.pais="";
    this.preventa.estado="";
    this.preventa.municipio="";
    this.preventa.colonia="";
    this.preventa.calle="";
    this.preventa.cp="";
    this.preventa.medio="";
  }
  secc_(c){
    this.secc=c;
    switch (c) {
      case 1:
        this.bdn_edit=0;
        this.limpia_form();        
        break;
      default:
        break;
    }
  }

}
